export const isTokenPresent = (to, from, next) => {
  if(localStorage.getItem('SWSTUDIO_ACCESS_TOKEN')){
    next();
  }
  else{
    next({name:'login'});
  }
};
